// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"style_titleWrapper__39pYQ","rowsWrapper":"style_rowsWrapper__1M9AJ","rowWrapper":"style_rowWrapper__1OWjU","text":"style_text__3WY4E"};